import * as React from 'react';
import type { SVGProps } from 'react';
const SvgComment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M6.663 2.25h6.68a4.44 4.44 0 0 1 4.407 4.47v4.507a4.44 4.44 0 0 1-4.407 4.47H6.859l-3.492 1.957A.75.75 0 0 1 2.25 17V6.72a4.44 4.44 0 0 1 4.408-4.47zm.003 1.5A2.94 2.94 0 0 0 3.75 6.711v9.009l2.546-1.427a.75.75 0 0 1 .367-.096h6.671a2.94 2.94 0 0 0 2.916-2.961V6.71a2.94 2.94 0 0 0-2.915-2.961z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComment;
